export const languageOptions = [
  { value: 'rw', label: 'Kinyarwanda' },
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
];

export const levelOptions = {
  language: languageOptions,
  nursery: [
    { value: 'nursery-1', label: 'nursery_1' },
    { value: 'nursery-2', label: 'nursery_2' },
    { value: 'nursery-3', label: 'nursery_3' },
  ],
  primary: [
    { value: 'p1', label: 'p1' },
    { value: 'p2', label: 'p2' },
    { value: 'p3', label: 'p3' },
    { value: 'p4', label: 'p4' },
    { value: 'p5', label: 'p5' },
    { value: 'p6', label: 'p6' },
  ],
  secondary: [
    { value: 's1', label: 's1' },
    { value: 's2', label: 's2' },
    { value: 's3', label: 's3' },
    { value: 's4', label: 's4' },
    { value: 's5', label: 's5' },
    { value: 's6', label: 's6' },
  ],
};